import gql from 'graphql-tag';

export const DOCUMENT_TYPE_FRAGMENT = gql`
  fragment DocumentTypeInfo on DocumentType {
    id
    name
    type
  }
`;

export const DOCUMENT_FRAGMENT = gql`
  fragment DocumentInfo on Document {
    id
    filename
    fileType
    base64Content
    type {
      ...DocumentTypeInfo
    }
  }
  ${DOCUMENT_TYPE_FRAGMENT}
`;
